import React, {useEffect, useState} from 'react';
import {setItemDateValues} from '../utils/dataFunctions';
import {makeStyles} from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const usePalletLedgerRowStyles = makeStyles((theme) => ({
    td: {
        position: 'relative',
        padding: '6px 12px 6px 12px'
    },
    tdNum: {
        width: 90,
        maxWidth: 90,
        position: 'relative',
        padding: '4px 8px 4px 8px'
    },
}));

/**
 * A component for displaying a Pallet Ledger entry
 *
 * @param entry
 * @returns {JSX.Element}
 * @constructor
 */
const PalletLedgerTableRow = ({entry}) => {

    const [entryDate, setEntryDate] = useState('');
    const classes = usePalletLedgerRowStyles();

    useEffect(
        () => {
            // Create a human-readable date string
            const modifiedDate = setItemDateValues(entry.modified);
            setEntryDate(modifiedDate.date_string);
        }, [entry]
    );

    return (
        <TableRow>
            <TableCell className={classes.td}>{entryDate}</TableCell>
            <TableCell align="right" className={classes.tdNum}>{entry.qty}</TableCell>
            <TableCell align="right" className={classes.tdNum}>{entry.total}</TableCell>
            <TableCell className={classes.td}>{entry.info}</TableCell>
            <TableCell className={classes.td}>{entry.notes}</TableCell>
            <TableCell className={classes.td}>{entry.username}</TableCell>
        </TableRow>
    );
}

export default PalletLedgerTableRow;
